import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Input } from './ui/input';
import { Button } from './ui/button';
import { Trash2, Plus } from 'lucide-react';

const genId = () =>
  typeof crypto !== 'undefined' && crypto.randomUUID
    ? crypto.randomUUID()
    : String(Date.now()) + Math.random().toString(16).slice(2);

function DayCardMobile({ day, columns, onUpdateDay, onRemoveDay, canRemove }) {
  const cols = Array.isArray(columns) ? columns : [];

  const handleAddRow = (type = 'item') => {
    onUpdateDay({ ...day, rows: [...day.rows, { id: genId(), type, text: '' }] });
  };

  const handleRemoveRow = (rowId) => {
    onUpdateDay({ ...day, rows: day.rows.filter((row) => row.id !== rowId) });
  };

  const handleUpdateRow = (rowId, updatedRow) => {
    onUpdateDay({ ...day, rows: day.rows.map((row) => (row.id === rowId ? updatedRow : row)) });
  };

  return (
    <Card className="mb-4">
      <CardHeader className="bg-slate-50">
        <div className="flex items-center justify-between">
          <CardTitle className="text-base">{day.date}</CardTitle>
          {canRemove && (
            <Button variant="ghost" size="sm" onClick={onRemoveDay} className="text-red-600">
              <Trash2 className="h-4 w-4" />
            </Button>
          )}
        </div>
      </CardHeader>
      <CardContent className="pt-4 space-y-3">
        {day.rows.map((row) => (
          row.type === 'text' ? (
            <div key={row.id} className="bg-slate-50 p-3 rounded font-semibold">
              <Input
                value={row.text != null ? row.text : (row.notes || '')}
                onChange={(e) => handleUpdateRow(row.id, { ...row, text: e.target.value })}
                placeholder="Abschnitts-Überschrift..."
                className="font-semibold"
              />
            </div>
          ) : (
            <div key={row.id} className="border border-slate-200 rounded p-3 space-y-2">
              <div className="flex items-center justify-between mb-2">
                <span className="text-xs text-slate-500 font-semibold">Zeile {day.rows.indexOf(row) + 1}</span>
                {day.rows.length > 1 && (
                  <Button
                    variant="ghost"
                    size="sm"
                    onClick={() => handleRemoveRow(row.id)}
                    className="h-6 text-slate-400"
                  >
                    <Trash2 className="h-3 w-3" />
                  </Button>
                )}
              </div>
              {cols.map((col) => (
                <div key={col.id}>
                  <label className="text-xs text-slate-600 font-medium">{col.label}</label>
                  <Input
                    value={row[col.id] || ''}
                    onChange={(e) => handleUpdateRow(row.id, { ...row, [col.id]: e.target.value })}
                    placeholder={col.label}
                    className="mt-1"
                  />
                </div>
              ))}
            </div>
          )
        ))}
        <div className="flex gap-2 pt-2">
          <Button onClick={() => handleAddRow('item')} variant="outline" size="sm" className="flex-1">
            <Plus className="h-4 w-4 mr-1" />
            Zeile
          </Button>
          <Button onClick={() => handleAddRow('text')} variant="outline" size="sm" className="flex-1">
            <Plus className="h-4 w-4 mr-1" />
            Text-Zeile
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}

export default DayCardMobile;
